import RouteTemplate from 'ember-route-template'
import { SharesByCollectionEdit } from 'teacher-ui-client/components/page/book-library/shares/by-collection/edit'

export default RouteTemplate(SharesByCollectionEdit)
